export enum EnumCajuInterest {
  ALREADY_KNOW = "Já conheço a Caju e quero contratar :)",
  MAKE_APOINTMENT = "Agendar reunião para conhecer e tirar dúvidas",
}